import * as Sentry from "@sentry/capacitor";
import * as SentryReact from "@sentry/react";
import { REGION, SENTRY_DSN, WEB_HOSTS } from "./environment/env";

const productionHosts = WEB_HOSTS;
const isProductionHost = productionHosts.includes(window.location.host);

Sentry.init(
  {
    dsn: SENTRY_DSN,
    integrations: [SentryReact.browserTracingIntegration()],
    environment: isProductionHost ? `production-${REGION}` : `development-${REGION}`,
    ignoreErrors: [
      "ResizeObserver loop limit exceeded",
      "ResizeObserver loop completed with undelivered notifications.",
    ],
  },
  // Forward the init method from @sentry/react
  SentryReact.init
);
